module.exports = __webpack_public_path__ + "img/to-do-list.8c314b10.png";